<template>
  <div id="app" class="App" :class="{ show: show }">
    <transition
        @enter="enter" @after-enter="afterEnter"
        @leave="leave" @after-leave="afterLeave"
        @before-enter="beforeEnter"
        :css="false" appear :mode="mode">
        <router-view v-if="loaded"/>
    </transition>
  </div>
</template>

<script>

import gsap from "gsap"
import Transition from '@/core/mixins/Transition'

export default {
  name: 'App',
  mixins: [ Transition ],
  data: () => ({
    loaded: false,
    show: false
  }),
  mounted(){
    this.$nextTick(()=>{
      this.loaded = true 
      gsap.delayedCall(1, ()=>this.show = true)
    })
  },

}
</script>

<style lang="stylus"> 

@import '~@/commons/fonts/Fonts'
@import '~@/commons/stylus/Global'

.App 
  display flex

  &__close
    position absolute
    background #fff
    border-radius 50%
    top 24px
    right 32px
    cursor pointer
    height 28px
    width 28px
    display flex
    align-items center
    justify-content center
    box-shadow 0px 2px 2px 0px rgba(0,0,0,0.25)
    cursor pointer 
    transition opacity .25s, transform .5s
    transition-delay 4.25s

    &-container 
      position relative
      width 100vw
      max-width 460px
      height 64px
      left 50%
      transform translateX(-50%)

      &.open 
        z-index 20000

      &.is-desktop 
        max-width 380px

    & svg
      width 40%

    &.closed
      transform translateY(-120px)
      transition-delay 0s
      opacity 1


</style>

